import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import SubmitButton from "@covertree/ui/buttons/SubmitButton";
import Form from "@covertree/ui/forms/Form";
import FormTextField from "@covertree/ui/forms/FormTextField";

import {
  defaultValues,
  type ForgotPasswordFormData,
  createValidationSchema,
} from "./form";
import type { UsernameType } from "../types";

interface Props {
  usernameType: UsernameType;
  submit: (formValue: ForgotPasswordFormData) => void;
}

export const ForgotPasswordForm = ({ usernameType, submit }: Props) => {
  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm({
    defaultValues,
    mode: "all",
    resolver: yupResolver(createValidationSchema(usernameType)),
  });
  return (
    <Box>
      <Form onSubmit={handleSubmit(submit)}>
        <Grid container>
          <Grid item xs={12}>
            <FormTextField
              id="username-field"
              name="username"
              label={usernameType === "email" ? "Email" : "Phone"}
              control={control}
            />
          </Grid>
          <SubmitButton
            loading={isSubmitting}
            disabled={!isValid || isSubmitting}>
            Send
          </SubmitButton>
        </Grid>
      </Form>
    </Box>
  );
};

export default ForgotPasswordForm;
